'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _creditCardsBan = require('../config/creditCardsBan');

var _creditCardsBan2 = _interopRequireDefault(_creditCardsBan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterBannedCreditCards = function filterBannedCreditCards(paymentMethods, blockedSchemes, countryCode) {
  var isAffectedCountry = _creditCardsBan2.default.affectedCountries.includes(countryCode);

  if (!isAffectedCountry) {
    return paymentMethods;
  }

  var filteredCardMethods = paymentMethods.activeCardMethods.filter(function (cardMethod) {
    return !blockedSchemes.includes(cardMethod.scheme);
  });

  var lastActiveCardIndex = paymentMethods.lastActiveCardIndex;

  var isLastActiveCardIndex = filteredCardMethods.some(function (cardMethod) {
    return cardMethod.cardIndex === lastActiveCardIndex;
  });

  if (!isLastActiveCardIndex) {
    lastActiveCardIndex = filteredCardMethods.length ? filteredCardMethods[0].cardIndex : 0;
  }

  return { activeCardMethods: filteredCardMethods, lastActiveCardIndex: lastActiveCardIndex };
};

exports.default = filterBannedCreditCards;